import firebase from 'firebase/app';

export async function getIllustrationRegions() {
    var db = firebase.firestore();
    return await db
        .collection('regions')
        .orderBy('identifier', 'asc')
        .get();
}

export async function createNewRegion(regionName, regionIdentifier) {
    var db = firebase.firestore();
    var regionsObj = {
        name: regionName,
        identifier: regionIdentifier,
    };
    const docRef = await db.collection('regions').add(regionsObj);
    return docRef.id;
}
